<script>
  import { fade } from 'svelte/transition';
  import { page } from '@inertiajs/svelte';
  import { createLoadObserver } from '@/js/utils/loadObserver';
  import responsive from '@/js/utils/responsive';

  let innerWidth = 0;
  $: mobile = innerWidth <= responsive.s;

  export let image;
  export let loading;
  export let imagePos = 0;

  let scrollEl, cardImage, type;

  const onload = createLoadObserver(() => {
    loading = !loading;
  });

  /**
   * Handle mouse enter
   */
  function handleMouseEnter(value) {
    visible = true;
    type = value;
    startImage();
  }

  /**
   * Render image
   */
  function renderImage() {
    const offset = 5;

    if ('top' == type) {
      imagePos -= offset;
    }
    if ('bottom' == type) {
      imagePos += offset;
    }

    if (imagePos <= 0) {
      imagePos = 0;
    }

    let maxScroll = cardImage.height - scrollEl.offsetHeight;

    if (imagePos >= maxScroll) {
      imagePos = maxScroll;
    }

    cardImage.style.transform = `translateY(-${imagePos}px)`;
  }

  let reqAnimationId;

  // use fuction to animate item
  function smoothAnimation() {
    renderImage();
    // animtion
    reqAnimationId = requestAnimationFrame(smoothAnimation);
  }

  // to start
  function startImage() {
    reqAnimationId = requestAnimationFrame(smoothAnimation);
  }
  // to end
  function stopImage() {
    visible = false;
    cancelAnimationFrame(reqAnimationId);
  }

  $: imagePos;

  let cursorX = 0;
  let cursorY = 0;

  let visible = false;

  function handleCursor(e) {
    const { top, left } = scrollEl.getBoundingClientRect();
    cursorX = e.clientX - left;
    cursorY = e.clientY - top;
  }
</script>

<svelte:window bind:innerWidth />

<div class="proto-scroll" bind:this={scrollEl} on:mousemove={handleCursor}>
  {#if loading}
    <div class="hero-loader" transition:fade>
      <div class="hero-loader__inner">
        <div
          class="hero-loader__spinner"
          style={`mask-image: url(${$page.props.asset_url}img/loader.svg);-webkit-mask-image: url(${$page.props.asset_url}img/loader.svg);`}
        />
        <img
          class="hero-loader__logo"
          src={`${$page.props.asset_url}img/caballero-logo-symbol.svg`}
          alt="Logo"
        />
      </div>
    </div>
  {/if}
  {#if visible && !mobile}
    <div
      class="cursor"
      style={`transform: translate(${cursorX}px, ${cursorY}px)`}
      transition:fade={{ delay: 0, duration: 100 }}
    >
      <div
        class="cursor__box"
        class:top={'top' == type}
        class:bottom={'bottom' == type}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14.367"
          height="8.167"
          viewBox="0 0 14.367 8.167"
          ><path
            d="M6.882,1.231,1.129,7l5.753,5.769"
            transform="translate(14.184 -0.129) rotate(90)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          /></svg
        >
      </div>
    </div>
  {/if}
  <div
    on:mouseenter={() => {
      handleMouseEnter('top');
    }}
    on:mouseleave={stopImage}
    class="proto-scroll__part proto-scroll__part--top"
  />
  <div
    on:mouseenter={() => {
      handleMouseEnter('bottom');
    }}
    on:mouseleave={stopImage}
    class="proto-scroll__part proto-scroll__part--bottom"
  />
  <img
    use:onload
    bind:this={cardImage}
    src={image.src}
    width={image.width}
    height={image.height}
    alt={image.alt}
    loading="lazy"
    style={`transform: translateY(-${imagePos}px)`}
  />
</div>

<style lang="scss">
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .cursor {
    pointer-events: none;
    user-select: none;

    position: absolute;
    z-index: 1000;
    top: 0;
    left: 0;

    &__box {
      position: absolute;
      top: 0;
      left: 0;

      opacity: 0.7;

      display: flex;
      align-items: center;
      justify-content: center;

      width: 4rem;
      height: 4rem;

      margin: {
        top: -2rem;
        left: -2rem;
      }

      border: 1px solid rgb(var(--white));
      border-radius: 50%;

      svg {
        width: 2rem;
        transition: all 0.25s;
      }

      &.top {
      }
      &.bottom {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }

  .proto-scroll {
    position: relative;
    overflow: hidden;
    height: 100%;
    width: 100%;

    img {
      width: 100%;

      transition: transform 0.7s ease-out;
      will-change: transform;
    }

    &__part {
      cursor: none;

      position: absolute;
      z-index: 1;
      left: 0;
      right: 0;
      height: 40%;

      &--top {
        top: 0;
      }

      &--bottom {
        bottom: 0;
      }
    }
  }

  .hero-loader {
    position: absolute;
    z-index: 10;
    inset: 0;

    background: rgb(var(--white));

    display: flex;
    align-items: center;
    justify-content: center;

    &__spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: {
        top: -3.75rem;
        left: -3.75rem;
      }

      display: block;
      width: 7.5rem;
      height: 7.5rem;
      border-radius: 50%;

      mask-size: contain;

      background: conic-gradient(
        from 0.25turn at 50%,
        var(--aqua-2),
        rgb(var(--white))
      );

      animation: spin 3s infinite linear;
    }

    &__logo {
      width: 3rem;
    }
  }
</style>
